interface INotification {
  type: NotificationType;
  message: string;
  displayTiming: NotificationDisplayTiming;
  displayDuration: NotificationDisplayDuration;
}

enum NotificationType {
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Success = 'success',
}

export enum NotificationDisplayTiming {
  Immediately = 'immediately',
  AfterPageRefresh = 'afterPageRefresh',
}

export enum NotificationDisplayDuration {
  Once = 'once',
  UntilConfirm = 'untilConfirm',
}

export { NotificationType };
export type { INotification };
